import { render, staticRenderFns } from "./MTour.vue?vue&type=template&id=629ca77f"
import script from "./MTour.vue?vue&type=script&lang=js"
export * from "./MTour.vue?vue&type=script&lang=js"
import style0 from "./MTour.vue?vue&type=style&index=0&id=629ca77f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports